module.exports = __webpack_public_path__ + "img/message-primary.cf34bc3a.svg";